export default "__VITE_ASSET__CwE5L2J$__"